import { useApplicationContext } from '../../utils/withApplicationContext';

export const useConsultantChatHost = () => {
  const { config } = useApplicationContext();

  return config.get<string>('builderChatHost') ?? '';
};
